import { render } from "./ficheCaisse.vue?vue&type=template&id=2145325e&scoped=true"
import script from "./ficheCaisse.vue?vue&type=script&lang=js"
export * from "./ficheCaisse.vue?vue&type=script&lang=js"

import "./ficheCaisse.vue?vue&type=style&index=0&id=2145325e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2145325e"]])

export default __exports__